export const WORK_SCHEDULE = (translate) => ({
  full_time: translate('full_time'),
  part_time: translate('part_time')
});

export const HEADER_MENU_LIST = (translate) => [
  { text: translate('header_job'), url: '/' },
  { text: translate('header_about_us'), url: '/about-us' },
  { text: translate('header_contact'), url: '/contact' }
];

export const LOCATION_LIST = ['İstanbul', 'İzmir'];

export const TYPEFORM_URL = 'https://bitexen.typeform.com/to/UNQP1Xbs';

export const FORM_FIELDS = {
  TITLE: 'title',
  LOCATION: 'location',
  WORK_SCHEDULE: 'workSchedule'
};
